Customer.Ticket ||= {}

class Customer.Ticket.ResponseAttachmentLabelView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/attachment/response_attachment_label']

  initialize: (attachment, file) ->
    @attachment = attachment
    @file = file
    @status = 'uploading'

  render: () ->
    @$el = $(@template(filename: @filename(), fileSize: @fileSize()))
    @attachment.$el.append(@$el)
    @$el.find('i').click(@destroy)

  isReady: ()->
    @status == 'ready'

  filename: ()->
    @file.name

  fileSize: ()->
    '(' + @_prettyBytes(@file.size) + ')'

  setReady: ()->
    @$el.find(".loading-attachment").hide()
    @status = 'ready'
    @$el.addClass('uploaded')

  destroy: ()=>
    @attachment.deleteFile(@)
    @status == 'failed'
    @trigger('remove:attachment')
    @$el.remove()
    @attachment._checkReady()

  setResponse: (res)->
    @response = res
    @setUrl(res.url)

  setUrl: (url)->
    @url = url

  toJSON: ->
    @response

  resetImage: =>
    @attachment.resetImage()

  _prettyBytes: (size, decimalPlaces = 0)=>
    index = Math.floor(Math.log(size) / Math.log(1024))
    unit = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][index]
    finalSize = size / Math.pow(1024, index)
    if finalSize < 100
      roundTo = Math.max(decimalPlaces, 2)
    else
      roundTo = decimalPlaces
    finalSize.toFixed(roundTo) * 1 + ' ' + unit
